/* eslint-disable max-classes-per-file */
export class AtgardAnmalanTradslagDTO {
    id?: number;
    tradslagId?: number;
    arealHa: number;
    antalPlantor?: number;
    sekvensnummer: number;
    guid: string;
    tag: AtgardAnmalanTradslagDTO;
}

export class AnmalanTradslag extends AtgardAnmalanTradslagDTO {
    id?: number;
    guid: string;
    tradslagId?: number;
    arealHa: number;
    antalPlantor?: number;
    sekvensnummer: number;
    tag: AtgardAnmalanTradslagDTO;

    constructor(atgTrad: AtgardAnmalanTradslagDTO) {
        super();
        this.id = atgTrad.id;
        this.guid = atgTrad.guid;
        this.tradslagId =atgTrad.tradslagId;
        this.arealHa = atgTrad.arealHa;
        this.antalPlantor = atgTrad.antalPlantor;
        this.sekvensnummer = atgTrad.sekvensnummer;
        this.tag = atgTrad.tag;
    }
}

export class TradslagDTO {
    id: number;
    kod: string;
    kortnamn: string;
    namn: string;
    sekvensnummer: number;
    externkod: string;
    tradslagsgruppering: string;
    fordelningsgrupp: string;
    varningProduktionsplan: boolean;
}

export class VKAtgardMbfDTO {
    anmalanMarkberedningsmetod?: string;
    anmalanForyngringsmetod?: string;
    anmalanTradslag?: AtgardAnmalanTradslagDTO[];
}

export class VKAtgardMbf extends VKAtgardMbfDTO {
    constructor(mbf?: VKAtgardMbfDTO) {
        super();
        this.anmalanMarkberedningsmetod = mbf?.anmalanMarkberedningsmetod;
        this.anmalanForyngringsmetod = mbf?.anmalanForyngringsmetod;
        this.anmalanTradslag = mbf?.anmalanTradslag ?? [];
    }
}
